import { SET_SETTINGS_BREADCRUMB, SET_SETTINGS_BREADCRUMB_LOCATION } from './chunk-Z36MVTLO.mjs';
import { produce } from 'immer';

var breadCrumbSettingsReducer = produce((state = [], action) => {
  switch (action.type) {
    case SET_SETTINGS_BREADCRUMB_LOCATION:
      return [...state, action.payload];
    case SET_SETTINGS_BREADCRUMB:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default = breadCrumbSettingsReducer;

export { reducers_default };
